import React, { useEffect } from 'react';
import { Button, Modal, Table } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';
import useFormRef from '../hooks/useFormRef';
import { Configuration } from '../api/types';
import ConfigurationForm from '../components/ConfigurationForm';
import { Mode } from '../store/types';
import { useStoreActions, useStoreState } from '../store/hooks';

const ConfigurationPage = () => {
  const [isVisible, setVisible] = React.useState(false);

  const { saveFormRef, formRef } = useFormRef<Configuration>();

  const { formatMessage } = useIntl();

  const { fetchConfiguration, updateConfiguration } = useStoreActions(
    actions => actions.configuration,
  );

  const { detail, isLoading } = useStoreState(state => state.configuration);

  const data = [
    {
      key: 'pricingVersion',
      name: formatMessage({ id: 'configuration.form.pricingVersion' }),
      value: detail.pricingVersion,
    },
    {
      key: 'discountVp',
      name: formatMessage({ id: 'configuration.form.discountVp' }),
      value: detail.discountVp,
    },
    {
      key: 'discountVpCalculation',
      name: formatMessage({ id: 'configuration.form.discountVpCalculation' }),
      value: detail.discountVpCalculation
        ? formatMessage({ id: 'enums.boolean.yes' })
        : formatMessage({ id: 'enums.boolean.no' }),
    },
  ];

  useEffect(() => {
    fetchConfiguration();
  }, [fetchConfiguration]);

  const updateConfigurationHandler = () => {
    formRef!.validateFields((err, configuration) => {
      if (!err) {
        updateConfiguration(configuration);
        setVisible(false);
      }
    });
  };

  return (
    <>
      <div className='configuration-page-header'>
        <Button
          type='primary'
          className='recalculate-button'
          loading={isLoading}
          onClick={e => {
            e.preventDefault();
            setVisible(true);
          }}
        >
          <FormattedMessage id='configuration.button.update' />
        </Button>
      </div>

      {/* <ConfigurationForm ref={saveFormRef} data={detail} mode={Mode.VIEW} /> */}

      <Table<any>
        loading={isLoading}
        dataSource={data}
        size='middle'
        rowKey='id'
        childrenColumnName='sourceRules'
        // onRow={({ id }) => ({
        //   onClick: e => {
        //     e.preventDefault();
        //     setVisible(true);
        //   },
        // })}
        columns={[
          {
            dataIndex: 'name',
            title: formatMessage({ id: 'configuration.table.column.name' }),
            width: 250,
          },
          {
            dataIndex: 'value',
            title: formatMessage({ id: 'configuration.table.column.value' }),
          },
        ]}
      />

      <Modal
        title={<FormattedMessage id='configuration.modal.title' />}
        visible={isVisible}
        width={700}
        onCancel={e => {
          e.preventDefault();
          setVisible(false);
        }}
        okText={<FormattedMessage id='common.update' />}
        onOk={updateConfigurationHandler}
      >
        <ConfigurationForm ref={saveFormRef} data={detail} mode={Mode.EDIT} />
      </Modal>
    </>
  );
};

export default ConfigurationPage;
